/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-pending-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM7.187 10A1.563 1.563 0 118.75 8.437 1.55 1.55 0 017.187 10zm5.625 0a1.563 1.563 0 111.563-1.563A1.55 1.55 0 0112.812 10z"/>'
  }
})
